import { render, staticRenderFns } from "./AssignVolunteerTeamDialog.vue?vue&type=template&id=04e9fdc7&scoped=true"
import script from "./AssignVolunteerTeamDialog.vue?vue&type=script&lang=js"
export * from "./AssignVolunteerTeamDialog.vue?vue&type=script&lang=js"
import style0 from "./AssignVolunteerTeamDialog.vue?vue&type=style&index=0&id=04e9fdc7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e9fdc7",
  null
  
)

export default component.exports